import Molde from "./MoldeTourTradicional";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function ValleSur() {
  return (
    <>
      <Molde
        image={"/images/valle-sur-portada.png"}
        title={"VALLE SUR"}
        subtitle={"(Medio Día)"}
        description={
          "El Valle Sur del Cusco es la denominación turística que reciben los atractivos turísticos localizados al sureste de la ciudad del Cuzco. Los más importantes son: Tipón, Piquillacta, la iglesia de San Pedro de Andahuaylillas, los humedales de Huasao y sus decenas de pueblos llenos de historia y tradiciones. Estos destinos se pueden visitar con un tour todo incluido o por propia cuenta."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 15.00"}
        moneda={"DOLARES"}*/
        picture1={            
          <>
          <div>
            <CardItinerario
              num="01"
              title="INICIO"
              lugar="TIPON"
              ></CardItinerario>

              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/tipon_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/tipon_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/tipon_3.png`} alt="" />
              </div>
          </div>
          </>
        }

        picture2={            
          <>
          <div>
            <CardItinerario
              num="02"
              title="PARADA"
              lugar="PIKILLACTA"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/piki_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/piki_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/piki_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture3={            
          <>
          <div>
            <CardItinerario
              num="03"
              title="PARADA"
              lugar="ANDAHUAYLILLAS"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/anda_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/anda_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/anda_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            
            <p className="text-primary-800 font-light">Asistencia permanente</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Boleto turistico</p>
            <p className="text-primary-800 font-light">Gastos extra</p>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Facil"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"5 Horas"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Cultural"}
              />
            </>
          }

        lugarvisita={
          <>
            <CardLugar
              icon={"01"}
              title={"Tipon"}
            />
            <CardLugar
              icon={"02"}
              title={"Pikillaqta "}
            />
            <CardLugar
              icon={"03"}
              title={"Andahuaylillas "}
            />
            
          </>
        }
        
        TourRecomienda={
          <>
            <CardRecomienda
                          img={"/images/montania_colores.png"}
                          title={"MONTAÑA 7 COLORES"}
                          puntuacion={"4.5"}
                          link={'/tour-tradicional/montania-colores'}
                        />
                        <CardRecomienda
                          img={"/images/valle-vip-5.png"}
                          title={"VALLE VIP"}
                          puntuacion={"5"}
                          link={'/tour-tradicional/valle-vip'}
                        />
                        <CardRecomienda
                          img={"/images/laguna_huamantay.png"}
                          title={"LAGUNA HUAMANTAY"}
                          puntuacion={"5"}
                          link={'/tour-tradicional/laguna-huamantay'}
                        />
                        <CardRecomienda
                          img={"/images/maras-moray-4.png"}
                          title={"MARAS-MORAY"}
                          puntuacion={"4.5"}
                          link={'/tour-tradicional/maras-moray'}
                        />
          </>
        }
      />
    </>
  );
}
